(function ($, sr) {
    var debounce = function (func, threshold, execAsap) {
        var timeout;
        return function debounced() {
            var obj = this, args = arguments;

            function delayed() {
                if (!execAsap)
                    func.apply(obj, args);
                timeout = null;
            };
            if (timeout)
                clearTimeout(timeout);
            else if (execAsap)
                func.apply(obj, args);

            timeout = setTimeout(delayed, threshold || 100);
        };
    };
    // smartresize
    jQuery.fn[sr] = function (fn) {
        return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr);
    };
})(jQuery, 'smartresize');

(function ($) {
    function refresh_size_queries() {
        var classes = [];
        var scrollbarwidth = getScrollbarWidth();
        window_width = $(window).width();
        window_height = $(window).height();
        is_phone = (window_width < 768);
        is_mobile = (window_width < 992);
        is_tablet_portrait = (window_width >= 768 && window_width < 992);
        is_tablet_landscape = (window_width >= 992 && window_width < 1200 && window_height <= 768);
        is_tablet = is_tablet_portrait || is_tablet_landscape;
        is_desktop = (window_width >= 992);
        is_desktop_large = (window_width >= 1200);
        is_desktop_medium = (window_width >= 1400);
        is_desktop_larger = (window_width >= 1500);

        if (is_phone) {
            classes.push('mq_phone');
        }
        if (is_mobile) {
            classes.push('mq_mobile');
        }
        if (is_tablet_portrait) {
            classes.push('mq_tablet_portrait');
        }
        if (is_tablet_landscape) {
            classes.push('mq_tablet_landscape');
        }
        if (is_tablet) {
            classes.push('mq_tablet');
        }
        if (is_desktop) {
            classes.push('mq_desktop');
        }
        if (is_desktop_large) {
            classes.push('mq_desktop_large');
        }
        if (is_desktop_larger) {
            classes.push('mq_desktop_larger');
        }


        $('html').removeClass('mq_phone');
        $('html').removeClass('mq_mobile');
        $('html').removeClass('mq_tablet_portrait');
        $('html').removeClass('mq_tablet_landscape');
        $('html').removeClass('mq_tablet');
        $('html').removeClass('mq_desktop');

        $('html').addClass(classes.join(' '));

        function getScrollbarWidth() {
            var outer = document.createElement("div");
            outer.style.visibility = "hidden";
            outer.style.width = "100px";
            outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
            document.body.appendChild(outer);
            var widthNoScroll = outer.offsetWidth;
            // force scrollbars
            outer.style.overflow = "scroll";
            // add innerdiv
            var inner = document.createElement("div");
            inner.style.width = "100%";
            outer.appendChild(inner);
            var widthWithScroll = inner.offsetWidth;
            // remove divs
            outer.parentNode.removeChild(outer);
            return widthNoScroll - widthWithScroll;
        }
    }

    function hotel_languages() {
        /* Display other languages on mouse enter only on single hotel */
        const language = document.querySelector('#languages');
        const otherLanguage = document.querySelector('#languages .other_languages');

        if (false) {
            language.addEventListener('mouseenter', () => {
                language.classList.add('active');
                gsap.to(otherLanguage, {autoAlpha: 1});
            });
            language.addEventListener('mouseleave', () => {
                language.classList.remove('active');
                gsap.to(otherLanguage, {autoAlpha: 0});
            });
        }
    }

    function manual_fancybox() {
        $('a[data-manual-fancy]').click(function () {
            var button = $(this);
            var data = button.data('src');
            if (!data) {
                return;
            }
            var html = $(data).text();
            $.fancybox.open(html, {
                'afterShow': function () {
                    if (typeof renderRecaptcha !== 'undefined') {
                        renderRecaptcha();
                    }
                    if (typeof gformInitDatepicker !== 'undefined') {
                        gformInitDatepicker();
                    }

                },
                arrows: false,
                infobar: false
            })
        })
    }

    function headerPosition() {
        const header = document.querySelector('#header');
        const headerBg = document.querySelector('#header .header-bg');
        const slideshow = document.querySelector('#slideshow-1');
        if ($('#slideshow-1').length !== 0) {
            ScrollTrigger.create({
                trigger: "#slideshow-1",
                start: "bottom top",
                end: "bottom top",
                onEnter: () => addClassHeader(),
                onLeaveBack: () => removeClassHeader(),
            });

            function addClassHeader() {
                header.classList.add('fixed');
            }

            function removeClassHeader() {
                header.classList.remove('fixed');
            }
        } else {
            header.classList.add('fixed');
        }

        if (slideshow !== 0 && slideshow !== null && slideshow !== undefined) {
            //console.log({scroll, limit, velocity, direction, progress})
            let boundSlideshow = slideshow.getBoundingClientRect();
            let boundBar = header.getBoundingClientRect();
            let gap = boundBar.bottom - boundSlideshow.bottom;

            if (gap > 0) {
                gsap.to(headerBg, {height: gap, ease: 'linear', duration: 0});
            } else {
                gsap.to(headerBg, {height: 0, ease: 'linear', duration: 0});
            }
        } else {
            gsap.to(headerBg, {height: '100%', ease: 'linear', duration: 0});
        }
    }

    window.isEmpty = function (obj) {
        // null and undefined are "empty"
        if (obj == null) return true;
        // Assume if it has a length property with a non-zero value
        // that that property is correct.
        if (obj.length > 0) return false;
        if (obj.length === 0) return true;
        // If it isn't an object at this point
        // it is empty, but it can't be anything *but* empty
        // Is it empty?  Depends on your application.
        if (typeof obj !== "object") return true;
        // Otherwise, does it have any properties of its own?
        // Note that this doesn't handle
        // toString and valueOf enumeration bugs in IE < 9
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    };

    function sidebarMenu() {
        /*
        * Animation to open / close the sidebar
        */
        const openBtn = $('#open_menu'),
            sidebar = $('#menu_sidebar_wrap'),
            close = sidebar.find('.close_sidebar');
        if (openBtn.length > 0 && sidebar.length > 0) {

            const menuSidebar = sidebar.find('.menu_sidebar_inner_left ul.menu > li');
            const menuSidebarBg = sidebar.find('.menu_sidebar .bg_sidebar');
            const menuSidebarClose = sidebar.find('.menu_sidebar .close__wrap');
            const boxItems = sidebar.find('.menu_sidebar_inner_right .box-highlight');
            const mobileLogo = $('#sidebar-mobile_logo');
            gsap.set(sidebar, {x: '-100%'});
            gsap.set(menuSidebarBg, {clipPath: 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)'});
            gsap.set(menuSidebar, {autoAlpha: 0});
            gsap.set(menuSidebarClose, {autoAlpha: 0});
            gsap.set(boxItems, {autoAlpha: 0});
            gsap.set(mobileLogo, {autoAlpha: 0});

            const tlSidebar = gsap.timeline({paused: true, ease: 'power3.inOut'});
            tlSidebar.to(sidebar, {x: 0, duration: 0.5});
            tlSidebar.to(document.documentElement, {overflow: 'hidden'});
            tlSidebar.to(menuSidebarBg, {clipPath: 'polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)', duration: 0.5});
            tlSidebar.to(menuSidebarBg, {scale: 1.1, transformOrigin: 'center center', duration: 1.6}, 'startEqual');
            tlSidebar.to(menuSidebarClose, {autoAlpha: 1, delay: 0.2}, 'startEqual');
            tlSidebar.to(mobileLogo, {autoAlpha: 1, delay: 0.2}, 'startEqual');
            tlSidebar.to(menuSidebar, {autoAlpha: 1, stagger: { amount: 0.5, from: "random" }, delay: 0.2}, 'startEqual');
            tlSidebar.to(boxItems, {autoAlpha: 1, stagger: { amount: 0.8, from: "random" }, delay: 0.2}, 'startEqual');
            tlSidebar.addPause();
            tlSidebar.to(document.documentElement, {overflow: 'auto'});
            tlSidebar.to(menuSidebar, {autoAlpha: 0, duration: 0.1}, 'finishEqual');
            tlSidebar.to(menuSidebarClose, {autoAlpha: 0, duration: 0.1}, 'finishEqual');
            tlSidebar.to(mobileLogo, {autoAlpha: 0, duration: 0.1}, 'finishEqual');
            tlSidebar.to(boxItems, {autoAlpha: 0, duration: 0.1}, 'finishEqual');
            tlSidebar.to(menuSidebarBg, {clipPath: 'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)', duration: 0.5, delay: 0.2});
            tlSidebar.to(sidebar, {x: '100%', duration: 0.5, delay: 0.2});

            openBtn.click(function () {
                tlSidebar.restart();
            });

            close.click(function () {
                tlSidebar.play();
            });
        }
    }

    function lenis() {
        //Initialize Lenis Smooth Scroll
        const lenis = new Lenis({
            smoothWheel: true
        });

        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }

        requestAnimationFrame(raf);

        //On scroll functions to use ever except for group homepage
        lenis.on('scroll', ({scroll, limit, velocity, direction, progress}) => {
            //console.log({scroll, limit, velocity, direction, progress})
            ScrollTrigger.update();
            headerPosition();
        });
    }

    $(window).load(function () {
        refresh_size_queries();
        if ($('.the_content table').length > 0) {
            $('.the_content table').each(function () {
                $(this).wrapAll('<div class="table_wrap"></div>');
            })
        }
    });

    $(document).on('ready', function () {
        //Register gsap plugin
        gsap.registerPlugin(ScrollTrigger);
        //Removes warnings from gsap when a target is not found
        gsap.config({nullTargetWarn: false});
        refresh_size_queries();
        Splitting();
        lenis();
        headerPosition();
        sidebarMenu();
        manual_fancybox();
        hotel_languages();
    });

    $(window).on('resize', function () {
        ScrollTrigger.refresh();
    });

    $(window).smartresize(function () {
        refresh_size_queries();
    });

})
(jQuery);
